module.exports = __webpack_public_path__ + "images/worshipped-c80aedd2a67f60499929d60f2c2a90b1.png";